module.exports = __webpack_public_path__ + "static/water-droplets-811d87bf0bbe571c5d0a78efddd2ecac.png";